/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type DisplayStatus = (typeof DisplayStatus)[keyof typeof DisplayStatus];

export const DisplayStatus = {
  pending: "pending",
  in_progress: "in_progress",
  delivered: "delivered",
  failed: "failed",
} as const;
